import { GroupMessage } from "../../interfaces/group-message.interface";

export class GroupMessageModel {
  loading: boolean;
  error: boolean;

  groupMessage: GroupMessage[];
	totalGroupMessage: number;
	roster: any[];
}